import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={97}
    height={20}
    fill="none"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path
        d="M11.21 10.65s-4.493-.473-.1 6.577c0 0-4.009-2.104-4.009-7.23 0-5.407 4.009-7.35 4.009-7.35-5.03 7.088.119
        6.739.119 6.739l7.235-.58C18.143 3.192 16.42.4 9.477.4 2.535.4.5 3.23.5 10s2.296 9.6 9.001 9.6 8.598-2.857
        8.955-8.524l-7.25-.427h.004ZM44.591.712h-5.606c-4.459 0-6.26 1.862-6.26 5.115 0 3.252 1.602 4.182 9.113
        8.363-7.872-2.964-8.932-2.592-8.932-2.592l.845 6.321c.092.78.749 1.367 1.52 1.367h4.923c5.53 0 5.868-2.611
        5.868-5.188 0-3.16-.469-4.09-8.452-8.271 8.114 2.726 8.513 2.308 8.513
        2.308V2.267c0-.86-.687-1.555-1.532-1.555ZM30.948 2.06a1.54 1.54 0 0 0-1.52-1.348L21.731.72c-.768
        0-1.417.576-1.517 1.347l-2.035 15.46c-.123.93.591 1.759 1.517 1.759h4.15L25.91 2.57c-.204 14.742.188
        16.72 3.824 16.72h1.728c.926-.004 1.64-.833 1.517-1.763L30.944 2.06h.004ZM76.344.712h-3.026c-2.177 0-3.613
        0-4.278 11.459C68.387.71 66.817.71 64.678.71h-2.976c-.849 0-1.532.696-1.532 1.556v15.464c0 .86.687 1.555
        1.532 1.555h2.742c2.346 0 3.656-.25-2.819-6.455 0 0 6.133 4.635 7.47 4.635 1.335 0 7.153-4.5 7.153-4.5-5.706
        5.917-5.28 6.324-2.838 6.324h2.934c.845 0 1.532-.695
        1.532-1.555V2.267c0-.86-.687-1.555-1.532-1.555ZM58.02.716l-1.326.007c-1.82 0-2.28-.007-3.49 13.71C52.482.857
        52.098.711 49.813.711h-1.551c-.845 0-1.532.695-1.532 1.555v12.607c0 1.997 1.962 4.416 6.47 4.416s6.351-1.866
        6.351-4.001V2.27c0-.86-.687-1.555-1.536-1.555h.004ZM87.472.4c-7.146 0-8.978 2.83-8.978 9.6s2.296 9.6 9.001
        9.6 9.001-2.83 9.001-9.6S94.622.4 87.472.4Zm.273 16.497s-.849-1.935-.849-6.893c0-4.957.849-6.893.849-6.893s.998
        2.711.998 6.893-.998 6.893-.998 6.893Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5.4h96v19.2H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
